import React, { Component, Fragment, useCallback } from 'react';
import axios from 'axios';
import { Card, Row, Col, Icon, Layout, Input, Select } from 'antd';
import { Menu, Dropdown, Button, message } from 'antd';
import { Breadcrumb } from 'antd';
import { EMAIL_ADDRESS_IS_INVALID, PHONE_NUMBER_INVALID, WIZARD } from '../../../utils/Constants'
import { Link } from 'react-router-dom';
import 'antd/dist/antd.css';
import { Tabs, Radio } from 'antd';
import { Typography } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import WizardSteps from './steps';
import WizardFooter from './wizard-footer';
import F from "../../../Functions";
import DataHandler from "../../../utils/DataHandler";
import { Translate } from "react-translated";
import BFileStatusSelection from './bfile-status-selection';
import * as _ from 'lodash'

const { Footer } = Layout



// const { Col, Divider, Row } = antd;
const { Title } = Typography;
const { TabPane } = Tabs;

const Option = Select.Option;


class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      places: [],
      dob_date: [],
      dob_months: [],
      dob_years: [],
      selectedMonth: '',
      selectedYear: ''
    };
  }

  componentDidMount() {
    this.populateMonths();
    this.populateYears();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedMonth !== this.state.selectedMonth || prevState.selectedYear !== this.state.selectedYear) {
      this.populateDays(this.state.selectedMonth, this.state.selectedYear);
    }
  }

  populateDays(month, year) {
    const daysInMonth = this.getDaysInMonth(month, year);
    const dob_date = [];
    for (let i = 1; i <= daysInMonth; i++) {
      const val = i < 10 ? "0" + i : i.toString();
      dob_date.push({ name: val, value: val });
    }
    this.setState({ dob_date });
  }

  getDaysInMonth(month, year) {
    if (!month) return 31; // default to 31 days if no month is selected

    month = parseInt(month, 10);
    year = parseInt(year, 10);

    switch (month) {
      case 2: // February
        return year && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) ? 29 : 28;
      case 4: case 6: case 9: case 11: // April, June, September, November
        return 30;
      default: // All other months
        return 31;
    }
  }

  populateMonths() {
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const dob_months = [];
    for (let i = 1; i <= 12; i++) {
      const val = i < 10 ? "0" + i : i.toString();
      dob_months.push({ name: monthNames[i - 1], value: val });
    }
    this.setState({ dob_months });
  }

  populateYears() {
    const dob_years = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= 1900; i--) {
      dob_years.push(i.toString());
    }
    this.setState({ dob_years });
  }

  fetchAddress = async (val) => {
    if (val.length > 2) {
      try {
        this.props.updateLoadingState(true);
        const resp = await axios.get(`/api/google_maps/google_search_maps?query=${val}`);
        if (resp.data.success === true)
          this.setState({ places: resp.data.response_json.results })
        this.props.updateLoadingState(false);
      } catch (error) {
        console.error("Error fetching address:", error);
        this.props.updateLoadingState(false);
      }
    } else {
      this.setState({ places: [] })
    }
  };

  handleAutoFill = async (placeId) => {
    const { updateField, handleAutoFilledSelected } = this.props
    try {
      this.props.updateLoadingState(true);
      const resp = await axios.get(`/api/google_maps/google_fetch_place_by_place_id?place_id=${placeId}`);
      if (resp.data.success === true) {
        let address = {
          "address": resp.data.street || "",
          "city": resp.data.city || "NA",
          "state": resp.data.state || "NA",
          "zipcode": resp.data.zip_code || "NA",
        }
        updateField("address", resp.data.street || "")
        // updateField("address_cont", resp.data.street2 || "NA")
        updateField("city", resp.data.city || "NA");
        updateField("state", resp.data.state || "NA");
        updateField("zipcode", resp.data.zip_code || "NA");
        if (!this.props.isExternalBFile) {
          handleAutoFilledSelected(address);
        }
        this.setState({
          places: []
        })
      }
      this.props.updateLoadingState(false);
    } catch (error) {
      console.error("Error fetching address:", error);
      this.props.updateLoadingState(false);
    }
  }

  renderDropDown = (location = []) => {
    return (
      <div style={{
        position: 'absolute',
        top: '80%',
        left: '3%',
        width: '95%',
        border: '1px solid #ccc',
        borderRadius: '4px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        zIndex: 10,
        fontSize: window.innerWidth <= 768 ? '12px' : '16px',
      }}
      >
        <div style={{
          padding: "5px 10px",
          display: "flex",
          justifyContent: "space-between",
        }}>
          Address Suggestion
          <Button onClick={() => { this.setState({ places: [] }) }}>
            <Icon type="close" />
          </Button>
        </div>
        <div style={{
          overflow: "auto",
          maxHeight: 500
        }}>
          {location.map((suggestion, index) => (
            <div
              key={index}
              style={{
                padding: '10px',
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => this.handleAutoFill(suggestion.place_id)}
              tabIndex="0"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  this.handleAutoFill(suggestion.place_id);
                }
              }}
            >
              <img
                src="https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png"
                alt="icon"
                style={{ width: '20px', marginRight: '10px' }}
              />
              <div>
                <strong>{suggestion.name}</strong>
                <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>
                  {suggestion.formatted_address}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  debouncedFetchAddress = _.debounce(this.fetchAddress, 300);

  updateField = (name, value) => {
    if (name === "profile_address") {
      this.props.updateField("address", value)
      this.props.updateField("profile_address_updated", true)
      this.debouncedFetchAddress(value);
    } else {
      this.props.updateField(name, value)
      let temp = value && value.trim() ? false : true;
      this.props.updateField('error', { ...this.props.wizard.error, [name]: temp })
    }
  }

  validateEmail = (email) => {
    if (this.props.isExternalBFile && email && !F.validateEmail(email)) {
      message.error(EMAIL_ADDRESS_IS_INVALID);
      return;
    }
  }

  handleBlur = (name, value) => {
    if (!this.props.isExternalBFile) {
      this.props.handleBlur(name, value);
    }
  }

  checkDuplicateCustomer = () => {
    this.props.checkDuplicateCustomer()
  }

  handleAutoFilledSelected = () => {
    if (!this.props.isExternalBFile) {
      this.props.handleAutoFilledSelected();
    }
  }


  render() {
    const { dob_date, dob_months, dob_years } = this.state;
    const { wizard, updateField, handleBlur, handleAutoFilledSelected, updateRadioBtnToggle } = this.props;
    // for Dob field
    // const dob_years = [];
    // const dob_months = [];
    // const dob_date = [];
    // const monthNames = [
    //   "January",
    //   "February",
    //   "March",
    //   "April",
    //   "May",
    //   "June",
    //   "July",
    //   "August",
    //   "September",
    //   "October",
    //   "November",
    //   "December",
    // ];

    // for (let i = 1; i <= 31; i++) {
    //   let val;
    //   if (i < 10) {
    //     val = "0" + i
    //     dob_date.push({ name: val, value: val });
    //   } else {
    //     val = i + ""
    //     dob_date.push({ name: val, value: val });
    //   }
    // }

    // for (let i = 1; i < 13; i++) {
    //   if (i < 10) {
    //     dob_months.push({
    //       name: monthNames[i - 1],
    //       value: "0" + i,
    //     });
    //   } else {
    //     dob_months.push({
    //       name: monthNames[i - 1],
    //       value: i + "",
    //     });
    //   }
    // }
    // for (let i = new Date().getFullYear(); i >= 1900; i--) {
    //   if (i < 10) {
    //     dob_years.push("0" + i);
    //   } else {
    //     dob_years.push(i + "");
    //   }
    // }
    // 

    return (
      <Fragment>
        <div className='stepBody'>
          <div style={{ marginTop: -22 }}>
            <Card className='cardoutline' >
              <div>
                {
                  !this.props.isExternalBFile && (
                    <Card className='scriptCard'>
                      <h6 className='scriptHeading'>Use the Intelligence Link to determine your proper limits of liability</h6>
                      <p className='scriptPara'>{wizard.status === 'Renewal' && wizard.carrier === WIZARD.CARRIER.COUNTRY_FINANCIAL ? "“(Client Name),the following questions aim to ensure we have all your insured assets listed correctly, at the current values, for your household protection. We do this to ensure that all of your asset values match up with the liability protection limits we have on your current policy. We understand that the current cost of everything has increased with inflation, and so have your asset values. These following questions will ensure that all your household assets are identified and that any replacement costs (including life insurance) have up-to-date values on your policy/ies. Let’s Begin!”" : wizard.status === 'Renewal' ? "“Here at our Agency we do things differently for your policy renewal. We are going to review your existing policy to make sure you qualify for all of our discounts and that your coverage satisfies your protection needs. We always start this conversation by reviewing your liability limits.The correct liability limits protect your household against accidents, lawsuits, and catastrophes. I'll ask you a few questions using our agency's Intelligence Link to identify any coverage gaps and make sure I don't miss any discounts”" : "“Liability limits on your policy are crucial to making sure your household is properly protected against accidents, lawsuits, and catastrophes. We do things differently at our agency & use a calculator that will suggest liability limits you need on your policy(ies). These next set of questions will help us determine whether any coverage gaps exist.”"}</p>
                    </Card>
                  )
                }

                {
                  this.props.isExternalBFile && (
                    <Card className='scriptCard'>
                      <h6 className='scriptHeading'>Please take a couple minutes to fill out this Intelligence Link so we can make sure you have, or we are quoting you the proper liability limits.</h6>
                      <p className='scriptPara'>
                        <strong>What is liability coverage?</strong>
                      </p>
                      <p className='scriptPara'>
                        Liability coverage is like a financial safety net that protects you if you accidentally hurt someone or damage their property. If someone gets injured because of something you did—like a fall at your home or a car accident—this coverage can help pay for their medical bills or lost wages. It also helps if you accidentally break or damage someone else’s property, like hitting their car or damaging a neighbor’s fence. And if someone sues you, it can cover legal fees and court costs, even if you’re not found at fault. Everyday examples include your dog biting a neighbor, your child breaking something valuable at a friend’s house, or accidentally backing into another car. Without liability coverage, you might have to pay for these things out of your own pocket, which can get expensive fast. That’s why it’s so important—it helps protect your savings and the things you own from the high costs of unexpected accidents.
                      </p>
                    </Card>
                  )
                }


              </div>
              <Title level={4} className='titleText'>Primary Policy Holder</Title>
              {/* Form Input */}
              <Card style={{ border: "none" }}>
                <Row
                  gutter={[16, 16]}
                >
                  <Col xs={24} sm={12} md={6} lg={6} >
                    <label className='label'>First Name<span className='asteriskIcon'>*</span></label>
                    <Input className={wizard && wizard.error && wizard.error['first_name'] && 'error'}
                      value={wizard.first_name}
                      onChange={(e) => this.updateField("first_name", e.target.value)}
                      onBlur={(e) => this.handleBlur("first_name", e.target.value)}
                      autocomplete="off"
                      maxLength={50}
                      autoComplete='off'
                      placeholder="Enter First Name" />
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={6}>
                    <label className='label'>Last Name<span className='asteriskIcon'>*</span></label>
                    <Input className={wizard && wizard.error && wizard.error['last_name'] && 'error'}
                      value={wizard.last_name}
                      autocomplete="off"
                      onChange={(e) => this.updateField("last_name", e.target.value)}
                      onBlur={(e) => this.handleBlur("last_name", e.target.value)}
                      maxLength={50}
                      autoComplete='off'
                      placeholder="Enter Last Name" />
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={6}>
                    <label className='label'>Phone Number<span className='asteriskIcon'>*</span></label>
                    <Input className={wizard && wizard.error && wizard.error['phone'] && 'error'}
                      value={F.phone_format(wizard.phone)}
                      autocomplete="off"
                      onChange={(e) => {
                        const input = e.target.value;
                        const inputValue = input.replace(/\D/g, ''); // Remove non-digit characters
                        if (/^\d*$/.test(inputValue) && inputValue.length <= 14) {
                          const updateNumber = F.phone_format(inputValue);
                          F.log("noor 3 " + updateNumber);
                          this.updateField("phone", updateNumber);
                        }
                        if (inputValue.length === 10)
                        // && !this.props.isExternalBFile
                        {
                          this.checkDuplicateCustomer();
                        }
                      }}
                      onBlur={() => {
                        const input = wizard.phone;
                        const inputValue = input.replace(/\D/g, '');
                        if (inputValue.length != 10) {
                          message.error(PHONE_NUMBER_INVALID);
                          return;
                        }
                      }}
                      placeholder="Enter Phone number" />
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={6}>
                    <label className='label'>Email</label>
                    <Input
                      value={wizard.email}
                      autocomplete="off"
                      onChange={(e) => this.updateField("email", e.target.value)}
                      maxLength={50}
                      autoComplete='off'
                      onBlur={(e) => {
                        this.handleBlur("email", e.target.value);
                        this.validateEmail(e.target.value);
                      }
                      }
                      placeholder="Enter Email Address" />
                  </Col>
                </Row>
                {wizard.carrier !== WIZARD.CARRIER.COUNTRY_FINANCIAL ? (
                  <div style={{ marginTop: 15 }}>
                    <Row gutter={[16, 16]}>
                      <Col span={24}>
                        {/* <label className='label'>DOB<span className='asteriskIcon'>*</span></label> */}
                        <label className='label'>DOB</label>
                      </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                      <Col xs={24} sm={12} md={6} lg={6}>
                        <Select
                          className={wizard && wizard.error && wizard.error['dob_yyyy'] && 'error'}
                          value={wizard.dob_yyyy}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          style={{ width: "100%" }}
                          onChange={(value) => {
                            this.updateField("dob_yyyy", value);
                            this.setState({ selectedYear: value });
                          }}
                          onBlur={() => this.handleBlur("dob_yyyy", wizard.dob_yyyy)}
                        >
                          <Option value={""} className='textContent'>{"Year"}</Option>
                          {dob_years.map((value, i) => (
                            <Option value={value} key={i} className='textContent'>
                              {value}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                      <Col xs={24} sm={12} md={6} lg={6}>
                        <Select
                          className={wizard && wizard.error && wizard.error['dob_mm'] && 'error'}
                          value={wizard.dob_mm}
                          style={{ width: "100%" }}
                          optionFilterProp="children"
                          filterOption={(input, option) => {
                            const children = option.props.children;
                            if (typeof children === 'string') {
                              return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }
                            if (typeof children === 'object' && children.props && children.props.text) {
                              return children.props.text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }
                            return false;
                          }}
                          showSearch
                          onChange={(value) => {
                            this.updateField("dob_mm", value);
                            this.setState({ selectedMonth: value });
                          }}
                          onBlur={() => this.handleBlur("dob_yyyy", wizard.dob_mm)}
                        >
                          <Option value={""} className='textContent'>{"Month"}</Option>
                          {dob_months.map((item, i) => (
                            <Option value={item.value} key={i} className='textContent'>
                              <Translate text={item.name} />
                            </Option>
                          ))}
                        </Select>
                      </Col>
                      {/* <Col className="" span={6}>
                        <Select
                          className={wizard && wizard.error && wizard.error['dob_dd'] && 'error'}
                          value={wizard.dob_dd}
                          style={{ width: "100%" }}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          onChange={(value) => this.updateField("dob_dd", value)}
                        >
                          <Option value={""}>{"Day"}</Option>
                          {dob_date.map((item, i) => (
                            <Option value={item.value} key={i}>
                              <Translate text={item.name} />
                            </Option>
                          ))}
                        </Select>
                      </Col> */}
                    </Row>
                  </div>
                ) : null}
                {/*address component*/}
                <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <label className='label'>
                      <Translate text={"Street Address 1"} />
                    </label>
                    <Input
                      onChange={(e) => this.updateField("profile_address", e.target.value)}
                      name="address"
                      value={wizard.address}
                      autocomplete="off"
                      maxLength={100}
                      autoComplete='off'
                      placeholder="Street 1" />
                    {this.state.places.length > 0 &&
                      this.renderDropDown(this.state.places)
                    }
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <label className='label'>
                      <Translate text={"Street Address 2"} />
                    </label>
                    <Input
                      onChange={(e) => this.updateField("address_cont", e.target.value)}
                      onBlur={(e) => this.handleBlur("address_cont", e.target.value)}
                      name="address_cont"
                      autocomplete="off"
                      maxLength={100}
                      autoComplete='off'
                      value={wizard.address_cont}
                      placeholder="Street 2" /></Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <label className='label'>
                      <Translate text={"City"} />
                    </label>
                    <Input
                      onChange={(e) => this.updateField("city", e.target.value)}
                      onBlur={(e) => this.handleBlur("city", e.target.value)}
                      name="city"
                      autocomplete="off"
                      maxLength={50}
                      autoComplete='off'
                      value={wizard.city}
                      placeholder="City" /></Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <label className='label'>
                      <Translate text={"State"} />
                    </label>
                    <Input
                      onChange={(e) => this.updateField("state", e.target.value)}
                      onBlur={(e) => this.handleBlur("state", e.target.value)}
                      name="state"
                      autocomplete="off"
                      maxLength={50}
                      autoComplete='off'
                      value={wizard.state}
                      placeholder="State" /></Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <label className='label'>
                      <Translate text={"Zipcode"} />
                    </label>
                    <Input
                      onChange={(e) => this.updateField("zipcode", e.target.value)}
                      onBlur={(e) => this.handleBlur("zipcode", e.target.value)}
                      name="zipcode"
                      autocomplete="off"
                      maxLength={15}
                      autoComplete='off'
                      value={wizard.zipcode}
                      placeholder="Zipcode" /></Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <label className="label">
                      <Translate text={"Country"} />
                    </label>
                    <Input
                      disabled
                      value={"United States"}
                    />
                  </Col>
                </Row>
              </Card>
              {/*  */}


              {/* Spouse Cards */}
              <Title level={4} className='titleText'>Spouse/Partner Info</Title>
              {/* Form Input */}
              <Card style={{ border: "none" }}>
                <Row
                  gutter={[16, 16]}
                >
                  <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                    <label className='label'>First Name</label>
                    <Input
                      value={wizard.spouse_first_name}
                      autocomplete="off"
                      onChange={(e) =>
                        this.updateField("spouse_first_name", e.target.value)
                      }
                      onBlur={(e) => this.handleBlur("spouse_first_name", e.target.value)}
                      maxLength={50}
                      autoComplete='off'
                      placeholder="Enter First Name" />
                  </Col>
                  <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                    <label className='label'>Last Name</label>
                    <Input
                      value={wizard.spouse_last_name}
                      autocomplete="off"
                      onChange={(e) =>
                        this.updateField("spouse_last_name", e.target.value)
                      }
                      onBlur={(e) => this.handleBlur("spouse_last_name", e.target.value)}
                      maxLength={50}
                      autoComplete='off'
                      placeholder="Enter Last Name" />
                  </Col>
                  {this.props.is_calculator_only ? (
                    <Fragment>
                      <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                        <label className='label'>DOB<span className='asteriskIcon'>*</span></label>
                        <Select
                          value={wizard.dob_mm}
                          style={{ width: "100%" }}
                          onChange={(value) => this.updateField("dob_mm", value)}
                          onBlur={(value) => this.handleBlur("dob_mm", value)}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                        >
                          <Option value={""}>{"MM"}</Option>
                          {dob_months.map((item, i) => (
                            <Option value={item.value} key={i}>
                              <Translate text={item.name} />
                            </Option>
                          ))}
                        </Select>
                      </Col>
                      <Col xs={24} sm={12} md={6} lg={6} xl={6} style={{ marginTop: 21 }}>
                        <Select
                          value={wizard.dob_yyyy}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          style={{ width: "100%" }}
                          onChange={(value) => this.updateField("dob_yyyy", value)}
                          onBlur={(value) => this.handleBlur("dob_yyyy", value)}
                        >
                          <Option value={""}>{"YYYY"}</Option>
                          {dob_years.map((value, i) => (
                            <Option value={value} key={i}>
                              {value}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                    </Fragment>
                  ) : null}
                </Row>

              </Card>
              {/*  */}


              {/* Did you know */}
              <Row style={{ display: 'flex', justifyContent: 'center' }} className='center'>
                <Col span={18} className='didyouKnowSection'>
                  {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                  <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                  <h4>Did You Know</h4>
                  {/* <p className='textContent'>
                    “Liability limits are usually never discussed and most of your customers are not properly covered.”
                  </p> */}
                  <p className='textContent'>
                    “Liability limits are usually never discussed and most households are not properly protected.”
                  </p>
                </Col>
              </Row>
              {/* <WizardFooter {...this.props} /> */}
            </Card>
          </div>
        </div>
        <div className='stepFooter'
        >
          <WizardFooter {...this.props} />
        </div>
      </Fragment >
    )
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step1_updated.js